var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SET_FORM_META, UPDATE_FORM_VALUES, PREPARE_WIZARD } from "../actions";
export var formReducer = function (state, action) {
    if (state === void 0) { state = {
        response: null,
        formWizard: null,
        showWizard: false,
        forms: {}
    }; }
    var type = action.type, name = action.name, source = action.source, otherProps = __rest(action, ["type", "name", "source"]);
    switch (action.type) {
        case SET_FORM_META:
            return __assign(__assign({}, state), { forms: __assign({}, state.forms) });
        case PREPARE_WIZARD:
            if (!state.response)
                return state;
            return __assign(__assign({}, state), { showWizard: true });
        case UPDATE_FORM_VALUES:
            return __assign(__assign({}, state), { forms: __assign(__assign({}, state.forms), otherProps) });
        default:
            break;
    }
    return state;
};
